{
  "sidebar": {
    "hubs": "Hubovi",
    "users": "Korisnici",
    "admins": "Administratori",
    "signOut": "Odjavi se"
  },
  "common": {
    "actions": "Akcije",
    "page": "Strana",
    "currentFile": "Trenutni fajl",
    "newFile": "Novi fajl",
    "uploadNewFile": "Otpremite novi fajl",
    "of": "od",
    "currency": "RSD",
    "hour": "sat",
    "locked": "Zaključan",
    "unlocked": "Otključan",
    "on": "ON",
    "off": "OFF",
    "noData": "Nema podataka",
    "performingAction": "Izvršavanje akcije...",
    "success": "Uspešno",
    "warning": "Upozorenje",
    "error": "Greška",
    "pleaseTryAgain": "Molimo pokušajte ponovno.",
    "noTableData": "Nema podataka za prikaz.",
    "changeLanguage": "Jezik CMS-a",
    "languageChanged": "Jezik uspešno promenjen",
    "failedToChangeLanguage": "Greška pri promeni jezika",
    "breadcrumbs": {
      "hubs": "Hubovi",
      "users": "Korisnici",
      "parkingSpots": "Parking mjesta",
      "admins": "Administratori"
    },
    "enums": {
      "hubStatus": {
        "ONLINE": "Online",
        "OFFLINE": "Offline",
        "total": "Ukupno"
      },
      "parkingSpotUsage": {
        "AVAILABLE": "Slobodan",
        "OCCUPIED": "Zauzet"
      },
      "parkingSpotUsageStatus": {
        "STARTED": "Počeo",
        "ENDED": "Završio"
      },
      "parkingSpotStatus": {
        "ONLINE": "Online",
        "OFFLINE": "Offline"
      },
      "userStatus": {
        "ACTIVE": "Aktivan",
        "INACTIVE": "Neaktivan",
        "total": "Ukupno"
      }
    },
    "errors": {
      "email": "Polje mora biti validna email adresa",
      "minlength": "Polje mora imati minimum {{requiredLength}} karaktera. Trenutna dužina je {{actualLength}}",
      "required": "Polje je obavezno",
      "maxlength": "Polje može imati maksimum {{requiredLength}} karaktera. Trenutna dužina je {{actualLength}}",
      "pattern": "Polje mora odgovarati šablonu {{requiredPattern}}",
      "min": "Polje mora biti minimum {{min}}",
      "max": "Polje može biti maksimum {{max}}"
    }
  },
  "confirmations": {
    "delete": "Obrisati ovu stavku?"
  },
  "buttons": {
    "no": "Otkaži",
    "yes": "Potvrdi"
  },
  "maps": {
    "latitude": "Geografska širina",
    "longitude": "Geografska dužina",
    "price": "Cena",
    "maxTime": "Maksimalno vreme",
    "status": "Status"
  }
}
